<template>
  <section v-loading="loading" id="view-test-information-sendouts">
    <div class="case-creation__card">
      <div class="case-creation__heading">
        <div class="title-with-icon">
          <span class="icon">
            <img
              src="@/assets/images/icons/icon-test-reports.svg"
              alt="icon"
              class="img-fluid"
            />
          </span>
          <h3 class="title">Test Reports</h3>
        </div>
      </div>
      <div
        v-if="getTestReportsData && getTestReportsData.length == 0"
        class="no-test-block"
      >
        No test reports found
      </div>
      <div class="test-tabs reportsTableWidth" id="vue-tabs">
        <el-tabs
          v-model="activeName"
          class="demo-tabs"
          @tab-click="updateSelectedTabQuery"
        >
          <el-tab-pane
            :table-props="{ height: 'calc(100vh - 300px)' }"
            class="table-border"
            v-for="(caseType, index) of caseTypes"
            :key="index"
            :label="caseType.name"
            :name="index + ''"
          >
            <div class="test-panel">
              <div class="primary-content-view-new" v-loading="loading">
                <div
                  class="listings listings__table listings__all-cases"
                  id="all-cases-listings"
                >
                  <el-table :data="caseType.reports" style="width: 100%">
                    <el-table-column
                      prop="action"
                      label="REPORTS"
                      :width="isLabAssistant ? '750' : '400'"
                    >
                      <template #default="scope">
                        <ul class="action-test-icons view-test">
                          <li
                            style="margin-right: 10px"
                            v-if="
                              scope.row.case_type == 'COVID' ||
                              scope.row.case_type == 'COVID_FLU'
                            "
                          >
                            <div
                              class="column-status"
                              v-if="scope.row.covid_status"
                            >
                              <span class="el-dropdown-link">
                                <el-tag
                                  :type="
                                    getCovidStatusType(scope.row.covid_status)
                                  "
                                  >{{ scope.row.covid_status }}</el-tag
                                >
                              </span>
                            </div>
                          </li>
                          <li
                            style="margin-right: 10px"
                            v-if="
                              scope.row.case_type ==
                                'RESPIRATORY_PATHOGEN_PANEL' ||
                              scope.row.case_type == 'URINALYSIS' ||
                              scope.row.case_type == 'UTI' ||
                              scope.row.case_type == 'TOXICOLOGY'
                            "
                          >
                            <div
                              class="column-status"
                              v-if="scope.row.result_status"
                            >
                              <span class="el-dropdown-link">
                                <el-tag
                                  :type="
                                    getCovidStatusType(scope.row.result_status)
                                  "
                                  >{{ scope.row.result_status }}</el-tag
                                >
                              </span>
                            </div>
                          </li>

                          <li
                            v-if="
                              !scope.row.is_supplemental_report ||
                              (scope.row.is_supplemental_report &&
                                scope.row.template_report_merged)
                            "
                          >
                            <el-button
                              class="action-download"
                              v-if="hasPermission('test_reports', 'download')"
                              @click="onDownloadReport(scope.row, false, false)"
                              title="Download"
                            >
                              <span>
                                <img
                                  v-if="!checkNewReport(scope.row)"
                                  class="testreports-active"
                                  src="@/assets/images/icons/Download_1.svg"
                                  alt="icon"
                                  style="width: 22px"
                                />
                                <img
                                  v-else
                                  class="testreports-active"
                                  src="@/assets/images/icons/Download_2.svg"
                                  alt="icon"
                                  style="width: 22px"
                                />
                              </span>
                            </el-button>
                          </li>
                          <li
                            v-if="
                              !scope.row.is_supplemental_report ||
                              (scope.row.is_supplemental_report &&
                                scope.row.template_report_merged)
                            "
                          >
                            <el-button
                              class="action-view"
                              @click="viewReport(scope.row)"
                              title="View"
                            >
                              <img
                                v-if="!checkNewReport(scope.row)"
                                class="testreports-active"
                                src="@/assets/images/icons/view_1.svg"
                                alt="icon"
                                style="width: 22px"
                              />
                              <img
                                v-else
                                class="testreports-active"
                                src="@/assets/images/icons/view_2.svg"
                                alt="icon"
                                style="width: 22px"
                              />
                            </el-button>
                          </li>
                        </ul>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="time"
                      label="DATE & TIME"
                      width="350"
                    >
                      <template #default="scope">
                        <span>
                          {{
                            momentWithTimezone(
                              scope.row.time,
                              "MM-DD-YYYY hh:mm A"
                            )
                          }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="mark"
                      label="MARK FOR PHYSICIAN"
                      width="350"
                      v-if="!isLabAssistant"
                    >
                      <template #default="scope">
                        <div class="physician-btn">
                          <el-switch
                            disabled
                            v-model="scope.row.mark_for_physician"
                          ></el-switch>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="type" label="TYPE" width="320">
                      <template #default="scope">
                        <span v-if="scope.row.is_supplemental_report == true"
                          >Supplemental Report</span
                        >
                        <span v-else-if="scope.row.is_amendement"
                          >Amendement Report</span
                        >
                        <span v-else>Regular Report</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import AppHelper from "@/mixins/AppHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import moment from "moment";
export default {
  data() {
    return {
      activeName: "",
      caseId: "",
      loading: false,
      testReports: [],
      caseTypes: [],
    };
  },
  mixins: [AppHelper, caseDataHelper, UserPermissionsHelper],

  computed: {
    ...mapGetters("sendOuts", ["getSendOutInformation"]),
    ...mapGetters("cases", [
      "getTestReportsData",
      "getReportGenerateStatus",
      "getDownloadReportData",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),

    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else if (status == "INCONSISTENT") {
          return "warning";
        } else if (status == "CONSISTENT") {
          return "success";
        } else {
          return "";
        }
      };
    },
    isCaseFinalized() {
      return (report) => {
        if (
          report &&
          report.mark_for_physician &&
          report.mark_for_physician == true
        ) {
          return true;
        } else {
          return false;
        }
      };
    },
    checkNewReport() {
      return (report) => {
        if (report && report.download_logs && report.download_logs.length) {
          if (this.getAuthenticatedUser && this.getAuthenticatedUser._id) {
            let userView = report.download_logs.find(
              (e) => e.user_id === this.getAuthenticatedUser._id
            );
            if (userView) {
              return true;
            } else {
              return false;
            }
          }
        }
      };
    },
  },
  async mounted() {
    if (this.getSendOutInformation && this.getSendOutInformation.case_id) {
      this.caseId = this.getSendOutInformation.case_id;
      await this.fetchReports();
    }
  },
  methods: {
    async fetchReports() {
      this.loading = true;
      await this.$store.dispatch("cases/fetchCaseTestReports", {
        case_id: this.caseId,
      });

      if (this.getTestReportsData && this.getTestReportsData.length) {
        this.testReports = JSON.parse(JSON.stringify(this.getTestReportsData));

        this.testReports = this.testReports.sort((a, b) => {
          return moment(b.time).valueOf() - moment(a.time).valueOf();
        });
        this.caseTypes = this.getSendOutInformation.case_types;

        this.caseTypes = this.caseTypes.map((e) => {
          return {
            case_type: e,
            name: caseConstants.CASE_TYPE_MAP[e],
            reports: this.testReports.filter(
              (report) => report.case_type === e
            ),
          };
        });

        if (
          this.testReports &&
          this.testReports.length &&
          this.caseTypes &&
          this.caseTypes.length
        ) {
          this.activeName = 0 + "";
        } else {
          this.activeName = "";
        }

        const selectedPanel = this.$route.query.selected_panel;
        if (selectedPanel) {
          let index = this.caseTypes.findIndex(
            (x) => x.case_type == selectedPanel
          );
          this.activeName = index > -1 ? index + "" : "uploadFiles";
        } else if (
          !this.hasPermission("cases", "report_view") &&
          this.caseTypes &&
          this.caseTypes.length
        ) {
          this.activeName = this.caseTypes[0].case_type + "";
        } else {
          // this.activeName = "uploadFiles";
        }
      } else {
        this.caseTypes = [];
        this.activeName = "";
      }
      this.loading = false;
      if (this.caseStatus == "COMPLETE") {
        if (this.activeName == "") {
          this.activeName = 0 + "";
        }
      }
    },
    updateSelectedTabQuery() {
      this.$router.push({
        query: {
          ...this.$route.query,
          selected_panel:
            this.activeName == "uploadFiles"
              ? "uploadFiles"
              : this.caseTypes[this.activeName].case_type,
        },
      });
    },
    async viewReport(report) {
      console.log(report);
      await this.generateReport(report, true, false);
      if (
        report.is_manually ||
        report.additional_report_merged ||
        report.additional_report_already_merged ||
        report.download_ready
      ) {
        let routerData = this.$router.resolve({
          name: "supplementaryReportView",
          params: {
            report_id: report._id,
            case_id: this.caseId,
          },
        });
        window.open(routerData.href, "_blank");
      } else {
        let routerData = this.$router.resolve({
          name: "ResultFileReport",
          params: {
            result_file_id: report.result_file_id,
            report_id: report.report_id,
            test_results_id: report.test_results_id,
          },
        });
        window.open(routerData.href, "_blank");
      }
    },
    async generateReport(report, skipDownload = false, showSuccess = true) {
      try {
        await this.$store.dispatch("cases/generateTestReport", {
          accession_id: this.getSendOutInformation.accession_id,
          case_type: report.case_type,
          report_id: report.report_id,
          test_results_id: report.test_results_id,
          result_file_id: report.result_file_id,
          skip_download: skipDownload,
        });

        if (this.getReportGenerateStatus && showSuccess) {
          successNotification("Test Report Downloaded Successfully");
        } else if (!this.getReportGenerateStatus) {
          errorNotification(
            this.getError || "Error while downloading test report"
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    async onDownloadReport(report, skipDownload = false, showSuccess = true) {
      try {
        this.loading = true;
        this.loadingText = "Downloading Report....";
        if (report.download_ready) {
          if (
            report.is_manually ||
            report.download_ready ||
            report.additional_report_already_merged
          ) {
            await this.downloadManuallyUploadedFile(report);
          } else {
            await this.generateReport(report, skipDownload, showSuccess);
          }
        } else {
          await this.generateReport(report, skipDownload, showSuccess);
          await this.fetchReports();
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async downloadManuallyUploadedFile(report) {
      let source = report.test_report_source;
      await this.$store.dispatch("cases/fetchTestReportDownloadURL", {
        path: "test_reports/" + source,
      });

      if (this.getDownloadReportData.data.download_url) {
        successNotification("Test Report Downloaded Successfully");
      } else if (!this.getDownloadReportData) {
        errorNotification(
          this.getError || "Error while downloading test report"
        );
      }
      let url = this.getDownloadReportData.data.download_url;
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss">
.test-reports-not-available {
  text-align: center;
  padding: 1rem 0;
  color: #f24a65;
  font-weight: 500;
}
.case-creation__heading {
  overflow: hidden;
}
#view-test-information-sendouts {
  .test-reports {
    display: grid;
    grid-template-columns: 200px auto;
    column-gap: 15px;
    .el-switch .el-switch__core {
      width: 34px !important;
      height: 14.5px;
      border: none;
      background-color: #0a5da6;
      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2px;
        left: 2.1px;
      }
    }
    .el-switch__label.is-active {
      color: #0a5da6;
    }
    .el-switch.is-checked {
      .el-switch__core {
        background-color: #4bb543 !important;
      }
      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2px;
        left: 38px;
      }
    }

    .single-reports {
      margin-left: 20px;
    }
  }
  .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
  }
  .test-tabs {
    .el-tabs__nav-scroll {
      padding: 0 15px;
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
    .el-tabs__header {
      margin-bottom: 5px;
    }
    .test-panel {
      padding: 5px 10px 10px;
      .title-icon {
        padding: 0 6px;
        min-height: 20px;
        border: none;
        background: none;
        img {
          vertical-align: text-top;
        }
      }
      .icons {
        display: flex;
        justify-content: flex-end;
        padding: 2px 7px 12px 7px;
        .el-button {
          padding: 0;
          min-height: 21px;
          border: none;
          background: none;
        }
        .el-icon {
          .icon {
            width: 18px;
            height: 18px;
            color: #2979ff;
            padding-top: 3px;
          }
          &.cancel {
            margin-left: 8px;
          }
        }
      }
      .el-table {
        background: #eef2f5;
        padding: 0 10px;

        .el-table__cell {
          padding: 5px 0;
        }
      }
      .el-table__header {
        border-spacing: 0 2.5px;
        color: rgba(0, 0, 0, 0.8);
      }
      .el-table__body {
        border-spacing: 0 2.5px;
      }
      .el-table thead {
        color: rgba(0, 0, 0, 0.8);
        font-weight: 500;
      }
      .hours {
        margin-left: 10px;
      }
      .el-icon-edit {
        min-height: 25px;
        padding: 0 5px;
        background-color: #f24a55;
        color: #ffff;
        border: none;
      }
      .edit-icon {
        cursor: pointer;
        position: relative;

        top: 3px;
      }
    }
    .el-tabs__active-bar {
      background-color: #0a5da6;
      border-radius: 25px;
      height: 2px;
    }
    .el-tabs__item.is-active {
      color: #0a5da6;
      font-weight: 500;
    }
    .el-tabs__item:hover {
      color: #828282;
    }
    .el-tabs__item {
      color: #828282;
    }
    .el-table {
      .el-table__cell {
        .cell {
          font-weight: 500 !important;
        }
      }
    }
    .types {
      padding-top: 1rem;

      .el-form-item {
        display: block !important;
        margin: 0;
      }
      .case-type {
        &.view-reports-dialog {
          .el-button {
            border: 1px dashed #bababc;
            min-height: 30px;
            padding: 0 34px;
            background-color: #f2f6f9;
            width: 100%;
            font-size: 11px;
            span {
              display: flex;
              align-items: center;
              justify-content: center;
              color: #333333;
              p {
                color: #333333;
                font-weight: 400;
              }
              img {
                margin-right: 6px;
              }
            }
          }
        }
        .el-input__inner {
          border: 1px solid #56ccf2cc;
          height: 30px;
        }
      }
      .btn {
        margin-top: 22px;
        .el-button {
          color: #fff;
          padding: 8px 24px;
          min-height: 30px;
          border-radius: 7px;
          background: linear-gradient(
            79.26deg,
            #f24a55 -13.43%,
            #0a5da6 137.71%
          );
          border: none;
        }
        .submit-report {
          color: #fff;
          padding: 8px 24px;
          min-height: 30px;
          border-radius: 7px;
          background: linear-gradient(
            79.26deg,
            #f24a55 -13.43%,
            #0a5da6 137.71%
          );
          border: none;
        }
      }
    }
    .view-test {
      display: flex;
      font: icon;
      align-items: center;

      .el-button {
        padding: 0;
        margin-right: 10px;
        min-height: 20px;
        border: none;
        background: none;
      }
      .resend-notify-button {
        color: #10182f;
        margin-right: 7px;
        padding: 4px 0;
        border-radius: 5px;
        &:hover {
          color: #0a5da6;
        }
      }
    }
  }
  .physician-btn {
    .el-switch .el-switch__core {
      width: 34px !important;
      height: 15px;
      border: none;
      background-color: #0a5da6;
      .el-switch__action {
        height: 9px;
        width: 9px;
        top: 3px;
        left: 2px;
      }
    }
    .el-switch__label.is-active {
      color: #0a5da6;
    }
    .el-switch.is-checked {
      .el-switch__core {
        width: 34px !important;
        height: 15px;
        border: none;
        background-color: #4bb543 !important;
      }
      .el-switch__action {
        height: 10px;
        width: 10px;
        top: 2.2px;
        left: 38.5px;
      }
    }
  }
  .tox-finalize-btn {
    margin-left: 20px;
    .el-button {
      border: 0.6px solid #273480;
      background: #f2f2f2;
      color: #273480;
      min-height: auto;
      padding: 5px 15px;
      text-align: center;
      font-size: 13px;
      letter-spacing: 0;
      &:hover,
      &:focus {
        color: #273480;
        border: 0.6px solid #273480;
        background: #f2f2f2;
      }
    }
  }
}
.no-test-block {
  color: #f24a55;
  display: flex;
  align-items: center;
  text-emphasis: center;
  height: 60px;
  justify-content: center;
}
.reportsTableWidth {
  .el-table {
    table {
      width: 100% !important;
    }
  }
  .el-table__body-wrapper {
    width: 100% !important;
  }
}
</style>
